import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@gemini/ui";
import { LocationDotIcon } from "@gemini/icons";
import { useI18n } from "@/shared/hooks";
import { useMapContext } from "../../../contexts/MapContext";
import { useMap } from "react-map-gl/mapbox";
export const MapFlyToCenter = () => {
    const { viewport } = useMapContext();
    const { current: map } = useMap();
    const { t } = useI18n();
    const handleFlyToCenter = () => {
        map === null || map === void 0 ? void 0 : map.flyTo({
            center: viewport.center,
            zoom: viewport.zoom,
            bearing: viewport.bearing,
            pitch: viewport.pitch,
        });
    };
    return (_jsx(Button, { icon: LocationDotIcon, onPress: handleFlyToCenter, variant: "secondary-floating", iconOnly: true, children: t("location.map.modal.controls.back_to_center") }));
};
